const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBbcnews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "800 300 1400 1400",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#b90005",
    d: "M 832.5,332.5 C 1277.17,332.5 1721.83,332.5 2166.5,332.5C 2166.5,777.167 2166.5,1221.83 2166.5,1666.5C 1721.83,1666.5 1277.17,1666.5 832.5,1666.5C 832.5,1221.83 832.5,777.167 832.5,332.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1cbcc",
    d: "M 1348.5,724.5 C 1270.83,724.5 1193.17,724.5 1115.5,724.5C 1115.5,797.5 1115.5,870.5 1115.5,943.5C 1193.17,943.5 1270.83,943.5 1348.5,943.5C 1270.67,944.499 1192.67,944.833 1114.5,944.5C 1114.5,870.833 1114.5,797.167 1114.5,723.5C 1192.67,723.167 1270.67,723.501 1348.5,724.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 1348.5,724.5 C 1348.5,797.5 1348.5,870.5 1348.5,943.5C 1270.83,943.5 1193.17,943.5 1115.5,943.5C 1115.5,870.5 1115.5,797.5 1115.5,724.5C 1193.17,724.5 1270.83,724.5 1348.5,724.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfd",
    d: "M 1384.5,723.5 C 1462.5,723.5 1540.5,723.5 1618.5,723.5C 1618.5,797.167 1618.5,870.833 1618.5,944.5C 1540.5,944.5 1462.5,944.5 1384.5,944.5C 1384.5,870.833 1384.5,797.167 1384.5,723.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 1654.5,724.5 C 1732.17,724.5 1809.83,724.5 1887.5,724.5C 1887.5,797.5 1887.5,870.5 1887.5,943.5C 1809.83,943.5 1732.17,943.5 1654.5,943.5C 1654.5,870.5 1654.5,797.5 1654.5,724.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3d4d4",
    d: "M 1654.5,724.5 C 1732.33,723.501 1810.33,723.167 1888.5,723.5C 1888.5,797.167 1888.5,870.833 1888.5,944.5C 1810.33,944.833 1732.33,944.499 1654.5,943.5C 1732.17,943.5 1809.83,943.5 1887.5,943.5C 1887.5,870.5 1887.5,797.5 1887.5,724.5C 1809.83,724.5 1732.17,724.5 1654.5,724.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b90507",
    d: "M 1840.5,871.5 C 1841.49,880.986 1841.83,890.652 1841.5,900.5C 1807.88,917.834 1773.21,920 1737.5,907C 1698.85,886.431 1684.02,854.598 1693,811.5C 1703.78,781.053 1724.95,762.22 1756.5,755C 1774.25,751.338 1791.91,751.671 1809.5,756C 1819.95,758.874 1830.29,762.041 1840.5,765.5C 1840.83,775.19 1840.5,784.856 1839.5,794.5C 1818.02,782.547 1795.02,777.047 1770.5,778C 1730.4,786.705 1714.23,811.205 1722,851.5C 1728.48,869.525 1740.98,881.358 1759.5,887C 1779.23,892.089 1798.56,890.756 1817.5,883C 1825.47,879.681 1833.14,875.847 1840.5,871.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b90407",
    d: "M 1176.5,754.5 C 1197.87,754.096 1219.2,754.596 1240.5,756C 1268.24,761.063 1280.74,777.563 1278,805.5C 1275.05,815.907 1268.89,823.74 1259.5,829C 1284.61,836.724 1295.44,853.557 1292,879.5C 1288.02,893.478 1279.19,902.978 1265.5,908C 1258.07,910.774 1250.4,912.441 1242.5,913C 1220.5,913.5 1198.5,913.667 1176.5,913.5C 1176.5,860.5 1176.5,807.5 1176.5,754.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b90407",
    d: "M 1446.5,754.5 C 1468.2,754.108 1489.86,754.608 1511.5,756C 1540.92,763.043 1552.42,781.21 1546,810.5C 1542.56,818.941 1536.73,825.107 1528.5,829C 1558.33,838.16 1568.5,857.66 1559,887.5C 1552.4,899.086 1542.56,906.586 1529.5,910C 1524.31,911.798 1518.98,912.631 1513.5,912.5C 1491.17,912.5 1468.83,912.5 1446.5,912.5C 1446.5,859.833 1446.5,807.167 1446.5,754.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfd",
    d: "M 1204.5,779.5 C 1213.84,779.334 1223.17,779.5 1232.5,780C 1249.13,784.759 1253.63,794.925 1246,810.5C 1241.02,815.908 1234.85,819.074 1227.5,820C 1219.84,820.5 1212.17,820.666 1204.5,820.5C 1204.5,806.833 1204.5,793.167 1204.5,779.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfd",
    d: "M 1474.5,779.5 C 1483.51,779.334 1492.51,779.5 1501.5,780C 1518.85,784.21 1523.69,794.376 1516,810.5C 1510.76,816.142 1504.26,819.309 1496.5,820C 1489.17,820.5 1481.84,820.666 1474.5,820.5C 1474.5,806.833 1474.5,793.167 1474.5,779.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 1204.5,845.5 C 1216.5,845.333 1228.5,845.5 1240.5,846C 1259.94,848.419 1266.77,858.919 1261,877.5C 1256.46,883.69 1250.3,887.19 1242.5,888C 1229.84,888.5 1217.17,888.667 1204.5,888.5C 1204.5,874.167 1204.5,859.833 1204.5,845.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 1474.5,845.5 C 1486.5,845.333 1498.5,845.5 1510.5,846C 1529.92,848.409 1536.76,858.909 1531,877.5C 1526.64,883.429 1520.81,886.929 1513.5,888C 1500.5,888.5 1487.5,888.667 1474.5,888.5C 1474.5,874.167 1474.5,859.833 1474.5,845.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d56669",
    d: "M 1840.5,871.5 C 1840.56,870.957 1840.89,870.624 1841.5,870.5C 1842.82,880.659 1842.82,890.659 1841.5,900.5C 1841.83,890.652 1841.49,880.986 1840.5,871.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d46162",
    d: "M 1446.5,754.5 C 1446.5,807.167 1446.5,859.833 1446.5,912.5C 1468.83,912.5 1491.17,912.5 1513.5,912.5C 1491.01,913.497 1468.34,913.831 1445.5,913.5C 1445.17,860.331 1445.5,807.331 1446.5,754.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfd",
    d: "M 1977.5,1039.5 C 1977.83,1052.34 1977.5,1065.01 1976.5,1077.5C 1946.62,1060.82 1914.96,1055.99 1881.5,1063C 1860.48,1071.21 1853.65,1086.05 1861,1107.5C 1866.06,1114.23 1872.56,1119.06 1880.5,1122C 1895.66,1126.94 1910.99,1131.28 1926.5,1135C 1946.07,1139.37 1962.91,1148.53 1977,1162.5C 1990.03,1180.32 1993.69,1199.99 1988,1221.5C 1981.65,1244.86 1967.15,1261.02 1944.5,1270C 1916.69,1278.97 1888.36,1280.97 1859.5,1276C 1844.7,1273.46 1830.7,1268.62 1817.5,1261.5C 1816.33,1248.18 1816.17,1234.85 1817,1221.5C 1850.15,1242.13 1885.65,1247.63 1923.5,1238C 1944.93,1228.1 1951.1,1212.27 1942,1190.5C 1932.68,1180.25 1921.18,1173.75 1907.5,1171C 1887.01,1167.06 1867.34,1160.72 1848.5,1152C 1825.27,1140.06 1813.93,1120.89 1814.5,1094.5C 1816.86,1061.97 1833.52,1040.47 1864.5,1030C 1903.3,1019.33 1940.97,1022.5 1977.5,1039.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ecbbbc",
    d: "M 1272.5,1029.5 C 1327,1028.5 1381.66,1028.17 1436.5,1028.5C 1436.83,1041.01 1436.5,1053.34 1435.5,1065.5C 1435.5,1053.5 1435.5,1041.5 1435.5,1029.5C 1381.17,1029.5 1326.83,1029.5 1272.5,1029.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebb9ba",
    d: "M 1745.5,1029.5 C 1760.67,1028.17 1776.01,1028.17 1791.5,1029.5C 1791.38,1030.11 1791.04,1030.44 1790.5,1030.5C 1775.68,1029.5 1760.68,1029.17 1745.5,1029.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 1172.5,1208.5 C 1172.78,1209.29 1173.28,1209.96 1174,1210.5C 1174.5,1150.17 1174.67,1089.83 1174.5,1029.5C 1188.17,1029.5 1201.83,1029.5 1215.5,1029.5C 1215.5,1110.83 1215.5,1192.17 1215.5,1273.5C 1200.59,1273.82 1185.76,1273.49 1171,1272.5C 1132.24,1211.96 1092.74,1151.96 1052.5,1092.5C 1052.44,1091.96 1052.11,1091.62 1051.5,1091.5C 1050.5,1152.16 1050.17,1212.83 1050.5,1273.5C 1036.83,1273.5 1023.17,1273.5 1009.5,1273.5C 1009.5,1191.83 1009.5,1110.17 1009.5,1028.5C 1024.41,1028.18 1039.24,1028.51 1054,1029.5C 1094.5,1088.51 1134,1148.18 1172.5,1208.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e29495",
    d: "M 1215.5,1029.5 C 1201.83,1029.5 1188.17,1029.5 1174.5,1029.5C 1174.67,1089.83 1174.5,1150.17 1174,1210.5C 1173.28,1209.96 1172.78,1209.29 1172.5,1208.5C 1173.5,1148.67 1173.83,1088.67 1173.5,1028.5C 1187.68,1028.17 1201.68,1028.5 1215.5,1029.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 1272.5,1029.5 C 1326.83,1029.5 1381.17,1029.5 1435.5,1029.5C 1435.5,1041.5 1435.5,1053.5 1435.5,1065.5C 1395.83,1065.5 1356.17,1065.5 1316.5,1065.5C 1315.5,1086.66 1315.17,1107.99 1315.5,1129.5C 1351.17,1129.5 1386.83,1129.5 1422.5,1129.5C 1422.5,1141.5 1422.5,1153.5 1422.5,1165.5C 1387.17,1165.5 1351.83,1165.5 1316.5,1165.5C 1315.5,1189.33 1315.17,1213.33 1315.5,1237.5C 1357.83,1237.5 1400.17,1237.5 1442.5,1237.5C 1442.5,1249.5 1442.5,1261.5 1442.5,1273.5C 1385.83,1273.5 1329.17,1273.5 1272.5,1273.5C 1272.5,1192.17 1272.5,1110.83 1272.5,1029.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfd",
    d: "M 1745.5,1029.5 C 1760.68,1029.17 1775.68,1029.5 1790.5,1030.5C 1771.35,1111.43 1749.85,1191.76 1726,1271.5C 1710.74,1273.47 1695.24,1274.14 1679.5,1273.5C 1663,1215.16 1646.67,1156.82 1630.5,1098.5C 1614.34,1156.8 1598.34,1215.14 1582.5,1273.5C 1566.83,1273.5 1551.17,1273.5 1535.5,1273.5C 1511.97,1192.72 1490.3,1111.39 1470.5,1029.5C 1486.15,1028.5 1501.82,1028.17 1517.5,1028.5C 1530.08,1095 1544.92,1161 1562,1226.5C 1578.46,1164.99 1594.46,1103.32 1610,1041.5C 1617.1,1040.19 1624.43,1039.52 1632,1039.5C 1639.57,1039.52 1646.9,1040.19 1654,1041.5C 1669.05,1102.37 1684.72,1163.04 1701,1223.5C 1717.44,1159.08 1732.27,1094.41 1745.5,1029.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e6a6a8",
    d: "M 1977.5,1039.5 C 1978.83,1052.34 1978.83,1065.34 1977.5,1078.5C 1976.89,1078.38 1976.56,1078.04 1976.5,1077.5C 1977.5,1065.01 1977.83,1052.34 1977.5,1039.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efc7c8",
    d: "M 1052.5,1092.5 C 1051.83,1152.83 1051.17,1213.17 1050.5,1273.5C 1050.17,1212.83 1050.5,1152.16 1051.5,1091.5C 1052.11,1091.62 1052.44,1091.96 1052.5,1092.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e6a2a4",
    d: "M 1316.5,1065.5 C 1316.5,1086.5 1316.5,1107.5 1316.5,1128.5C 1352.17,1128.5 1387.83,1128.5 1423.5,1128.5C 1423.83,1141.01 1423.5,1153.34 1422.5,1165.5C 1422.5,1153.5 1422.5,1141.5 1422.5,1129.5C 1386.83,1129.5 1351.17,1129.5 1315.5,1129.5C 1315.17,1107.99 1315.5,1086.66 1316.5,1065.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d76c6f",
    d: "M 1316.5,1165.5 C 1316.5,1189.17 1316.5,1212.83 1316.5,1236.5C 1358.67,1236.17 1400.67,1236.5 1442.5,1237.5C 1400.17,1237.5 1357.83,1237.5 1315.5,1237.5C 1315.17,1213.33 1315.5,1189.33 1316.5,1165.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbcnews);
export default __webpack_public_path__ + "static/media/bbcnews.a52ef91df29f5241d39d7b6cb47029fe.svg";
export { ForwardRef as ReactComponent };